
import HNSColors from "../../../../../ui library/HNSColors";

import GenericButton from "./GenericButton";

export default function CancelButton({ disabled, onClick }) {
  return (
    <GenericButton
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      sx={{
        border: "1px solid",
        backgroundColor: HNSColors.neutrals[900],
        color: HNSColors.secondary[500],
        borderColor: HNSColors.secondary[500],
        "&:hover": {
          backgroundColor: HNSColors.secondary[900],
          color: HNSColors.secondary[500],
          borderColor: HNSColors.neutrals[900],
        },
      }}
    >
      Cancel
    </GenericButton>
  );
}
